/**
 * MSW Overrides: Availability Ancillaries scenario
 *
 * Returns the real availability response but with `ancillaries` injected at the
 * top level of the response (alongside `id`, `outbound`, and `inbound`).
 * These represent subscription benefits (e.g. checked bag) shown in the
 * "Plan includes" accordion on the customize page.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_AVAILABILITY_ANCILLARIES=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse, bypass } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { SelectedAncillaryPassenger, TripSearchResponse } from '@cvo/domain';

export const MOCK_INCLUDED_ANCILLARIES: SelectedAncillaryPassenger[] = [
  {
    personId: 'pax-1',
    outbound: [
      {
        code: 'CB_23',
        type: 'BAGGAGE',
        details: { weight: 23, units: 'kg', quantity: 1 } as unknown as string,
        origin: 'INCLUDED_IN_PLAN',
        quantity: 1,
        price: { amount: '0.00', currency: 'EUR' },
      },
      {
        code: 'CABINBAG',
        type: 'BAGGAGE',
        details: { weight: 10, units: 'kg', quantity: 1 } as unknown as string,
        origin: 'INCLUDED_IN_PLAN',
        quantity: 1,
        price: { amount: '0.00', currency: 'EUR' },
      },
    ],
    inbound: [
      {
        code: 'CB_23',
        type: 'BAGGAGE',
        details: { weight: 23, units: 'kg', quantity: 1 } as unknown as string,
        origin: 'INCLUDED_IN_PLAN',
        quantity: 1,
        price: { amount: '0.00', currency: 'EUR' },
      },
      {
        code: 'CABINBAG',
        type: 'BAGGAGE',
        details: { weight: 10, units: 'kg', quantity: 1 } as unknown as string,
        origin: 'INCLUDED_IN_PLAN',
        quantity: 1,
        price: { amount: '0.00', currency: 'EUR' },
      },
    ],
  },
];

export function createAvailabilityAncillariesOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.post(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.TRIP_SEARCH)}`,
      async ({ request }) => {
        const originalResponse = await fetch(bypass(request));
        const data: TripSearchResponse = await originalResponse.json();

        const result: TripSearchResponse = {
          ...data,
          ancillaries: MOCK_INCLUDED_ANCILLARIES,
        };

        console.log('[MSW] availability ancillaries injected:', result.ancillaries);

        return HttpResponse.json(result);
      },
    ),
  ];
}
